import { useNavigate } from 'react-router-dom';
import "./RiceCategory.css";
import riceImage from "../assets/rice-bag.jpeg"

const RiceCategory = () => {
   const navigate = useNavigate();
  return (
    <section className="rice-section">
      <div className="heading">
        <span className="sub-title">OUR PRODUCTS</span>
        <h2 className="elementor-heading-title elementor-size-default">Rice Category</h2>
        <p className="elementor-heading-title elementor-size-default">
          Premium grains sourced and packed under the Burooj name —
          starting with our flagship basmati.
        </p>
      </div>

      <div className="product-card">
        <div className="product-image">
          <img
            src={riceImage}
            alt="Burooj Classic Premium Basmati Rice"
          />
        </div>

        <div className="product-content">
          <span className="badge">FEATURED PRODUCT</span>

          <h2 className="elementor-heading-title elementor-size-default">
            Burooj Classic Premium Basmati Rice
          </h2>

          <p className="elementor-heading-title elementor-size-default" style={{ marginBottom: "12px" }}>
            1121 Indian Steam Basmati Rice — XXXL Extra Long Grain
          </p>

          <div className="specs-grid">
            <div className="spec">
              <span>VARIETY</span>
              <strong>1121 Basmati</strong>
            </div>

            <div className="spec">
              <span>PROCESS</span>
              <strong>Steam</strong>
            </div>

            <div className="spec">
              <span>ORIGIN</span>
              <strong>India</strong>
            </div>

            <div className="spec">
              <span>GRAIN</span>
              <strong>XXXL Extra Long</strong>
            </div>

            <div className="spec">
              <span>GRADE</span>
              <strong>Classic Premium</strong>
            </div>

            <div className="spec">
              <span>PACK</span>
              <strong>35 kg</strong>
            </div>
          </div>

          <ul className="features">
            <li>Aromatic, naturally grown long grain</li>
            <li>Aged to perfection for fluffier cooking</li>
            <li>Ideal for biryani, pulao and everyday meals</li>
          </ul>

          <div className="action-row">
            <button onClick={() => navigate('/contacts/')}>Enquire for Pricing</button>
            <span>Prices on request — market rates apply.</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RiceCategory;